export const getOnBackdropClick = (alerts, topAlert, closeAlert) => {
  if (!topAlert) return undefined;

  const alert = alerts.find((a) => a.key === topAlert);
  if (alert?.config?.isRequired) return undefined;

  return () => closeAlert(topAlert);
};
